<template>
  <div>
    <div>
      <div>
        <font-awesome-icon
          v-if="icon"
          :icon="icon.iconName"
          class="icon-preview"
        />
      </div>
      <v-text-field
        label="Search Icon"
        v-model="search"
        @keyup="scrollToSelected"
      />
    </div>
    <ul ref="list" :style="{ height }">
      <li
        v-for="(filteredIcon, index) in filteredIcons"
        :key="index"
        :class="isSelected(filteredIcon) ? 'selected' : null"
        @click="icon = filteredIcon"
      >
        <font-awesome-icon
          :icon="[filteredIcon.prefix, filteredIcon.iconName]"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { kebabCaseToCamel, camelCaseToKebabCase } from "../plugins/rules";

library.add(fas, fab);
export default {
  name: "IconPicker",
  components: {
    FontAwesomeIcon
  },
  props: {
    value: String,
    height: {
      type: String,
      default: "300px"
    }
  },
  data: () => ({
    search: "",
    icon: null
  }),
  mounted() {
    if (this.value) {
      this.icon = this.icons[
        Object.keys(this.icons).find(
          icon => this.icons[icon].iconName === camelCaseToKebabCase(this.value)
        )
      ];
      this.scrollToSelected();
    } else {
      this.icon = this.icons[Object.keys(this.icons)[0]];
    }
  },
  computed: {
    icons: () => ({
      ...fas,
      ...fab
    }),
    filteredIcons() {
      return Object.keys(this.icons)
        .filter(
          key =>
            key !== "faFontAwesomeLogoFull" &&
            this.icons[key].iconName.includes(this.search)
        )
        .map(key => this.icons[key]);
    }
  },
  methods: {
    scrollToSelected() {
      const selected = this.$refs.list.getElementsByClassName("selected");
      if (selected.length) {
        selected[0].scrollIntoView();
      }
    },
    isSelected(icon) {
      return icon.iconName === camelCaseToKebabCase(this.value);
    }
  },
  watch: {
    icon(value) {
      this.$emit("input", value && kebabCaseToCamel(value.iconName));
    }
  }
};
</script>
<style scoped>
ul {
  box-sizing: border-box;
  overflow-y: scroll;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 10px;
  margin: 0;
}

li {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin: 5px;
  width: 50px;
  height: 50px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
}

li > svg.svg-inline--fa {
  width: 2em;
  height: 2em;
}

li.reset {
  transition: none;
  color: red;
}

li.reset:hover,
li.reset.selected {
  transform: none;
  background-color: red;
  color: white;
}

li:hover {
  background-color: #5a5a5a;
  color: white;
  cursor: pointer;
  transform: scale(1.5);
  border: 1px solid transparent;
}

li.selected {
  transform: scale(2);
  background-color: #1f8aff;
  color: white;
  border: none;
}

.icon-preview {
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px;
  width: 60px;
  height: 60px;
  border-radius: 10px;
}

.btn {
  color: white;
  width: 100%;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 5px;
  outline: none;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3);
  background-color: #bd2130;
  cursor: pointer;
}

.btn:active {
  color: #fff;
  background-color: #900b18;
}
</style>
